import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import "./JuryScoreBoard.scss";
import {
  Description,
  RedContent,
  RedMainHeading,
  StatusSubContent,
  SubGreyHeading,
} from "../../Global/GlobalText";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";
import {
  InputTextarea,
  InputType,
  SelectBgWhiteBorder,
} from "../../Global/GlobalFormElement";
import {
  GreyBackgroundButton,
  GreyBorderButton,
  RedBackgroundButton,
} from "../../Global/GlobalButton";
import { JuryTitleBar } from "../../Global/JuryTitleBar/JuryTitleBar";
import { useLocation, useNavigate } from "react-router-dom";
import { EXCHNAGE_URL, EXCHNAGE_URL_JUDGE } from "../../../Url/Url";
import axios from "axios";
import { toast } from "react-toastify";
import { evaluate } from "mathjs";
import { useLoading } from "../../LoadingContext";

export const JuryScoreBoard = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [judgingData, setJudgingData] = useState([]);
  const [judgingFieldData, setJudgingFieldData] = useState([]);
  const [normalJudgeData, setNormalJudgeData] = useState([]);
  const [selectedScores, setSelectedScores] = useState({});
  const [formSchema, setFormSchema] = useState([]);
  const [entryFormId, setEntryFormId] = useState("");
  const [scoreValue, setScoreValue] = useState("");
  const [comments, setComments] = useState("");
  const token = localStorage.getItem("juryToken");
  const searchParams = new URLSearchParams(location.search);
  const judgemail = searchParams.get("judgemail");
  const eventId = searchParams.get("eventId");
  const roundId = searchParams.get("roundId");
  const [showMediaModal, setShowMediaModal] = useState(false);
  const [selectedMedia, setSelectedMedia] = useState(null);
  const hasFetched = useRef(false);
  const { setLoading } = useLoading();
// ✅ Add this helper function at the top of your component
const containsHTML = (text) => {
  if (!text) return false;
  return /<[a-z][\s\S]*>/i.test(text);
};
  const {
    logoImg,
    eventName,
    fName,
    lName,
    awardCat,
    juryData,
    selectedAwardId,
    queryParams,
    eventIdd,
    submission_id,
    judgeId,
    awardCatId,
  } = location.state || {};


  //= media--//
  const handleViewMedia = async (media) => {
    try {
      const res = await axios.get(
        `https://api.awardsuite.in/api/media/${media.id}`,
        {
          headers: {
            authorization: `Bearer ${localStorage.getItem("juryToken")}`,
          },
        }
      );

      setSelectedMedia({
        ...media,
        file_url: res.data.url,
        mime_type: res.data.mimeType,
      });

      setShowMediaModal(true);
    } catch (err) {
      console.error(err);
      toast.error("Media load failed");
    }
  };


  useEffect(() => {
    if (!judgemail || !eventId || !roundId) {
      navigate("/404");
    }
  }, [judgemail, eventId, roundId, navigate]);

  const fetchDataToScore = async (eventId, awardId, submissionId, roundId) => {
    try {
      setLoading(true);

      const response = await axios.get(
        `${EXCHNAGE_URL_JUDGE}/fetchDataToScore?eventId=${eventId}&awardId=${awardId}&submission_id=${submissionId}&roundId=${roundId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200 && response.data) {
        toast.success("Submission Data Fetched Successfully");
        console.log("Fetched Data:", response.data);
        const nData = response.data.data.submissionData;
        const data = response.data.data.scorecards;
        const fieldData = response.data.data.submissionData.fields;
        const id = response.data.data.submissionData.entry_form_id;
        setEntryFormId(id);
        setNormalJudgeData(nData);
        setJudgingData(data);
        setJudgingFieldData(fieldData);
      } else {
        toast.info("No Data Found for the Selected Submission");
      }

    } catch (error) {
      toast.error(`Failed to Fetch Submission Data: ${error}`);
      console.error("Error fetching submission data:", error);
      navigate(`/jury-dashboard?${new URLSearchParams(queryParams).toString()}`);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (
      hasFetched.current ||
      !eventIdd ||
      !selectedAwardId ||
      !submission_id ||
      !roundId
    ) {
      return;
    }

    hasFetched.current = true;
    fetchDataToScore(eventIdd, selectedAwardId, submission_id, roundId);
  }, [eventIdd, selectedAwardId, submission_id, roundId]);



  const hasFetchedOnce = useRef(false);

  const handleEntryForm = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${EXCHNAGE_URL}/entryForm?eventId=${eventIdd}&entryFormId=${entryFormId}`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${localStorage.getItem("juryToken")}`,
          },
        }
      );
      if (response.status === 200) {
        const fetchedFields = response.data.data.form_schema;
        const jsonArray = JSON.parse(fetchedFields);
        setFormSchema(jsonArray);
      } else {
        toast.error("Failed to fetch the Entry form.");
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    } finally {
      setLoading(false);
    }
  };




  useEffect(() => {
    if (entryFormId && !hasFetchedOnce.current) {
      handleEntryForm();
      hasFetchedOnce.current = true;
    }
  }, [entryFormId]);
  const handleScoreChange = (scoreFormId, dataName, value) => {
    setSelectedScores((prevScores) => ({
      ...prevScores,
      [`${scoreFormId}-${dataName}`]: Number(value),
    }));
  };

  const totalScore = judgingData.reduce((sum, entry) => {
    const formSchema = JSON.parse(entry.form_schema);
    const titleFields = formSchema.flatMap((schema) =>
      schema.fields.filter((field) => field.label === "Title")
    );

    return (
      sum +
      titleFields.reduce((subSum, field) => {
        const scoreKey = `${entry.scoreFormId}-${field.dataName}`;
        const score = selectedScores[scoreKey] || 0;
        return subSum + score;
      }, 0)
    );
  }, 0);

  const maxTotalScore = judgingData.reduce((sum, entry) => {
    const formSchema = JSON.parse(entry.form_schema);
    const titleFields = formSchema.flatMap((schema) =>
      schema.fields.filter((field) => field.label === "Title")
    );
    return (
      sum +
      titleFields.reduce(
        (subSum, field) => subSum + Number(field?.maxValue || 0),
        0
      )
    );
  }, 0);

  const handleSubmitScores = async () => {
    try {
      setLoading(true);
      const payload = {
        eventId: eventIdd,
        awardId: selectedAwardId,
        roundId: roundId,
        judgeId: judgeId,
        submission_id: submission_id,
        abstain: normalJudgeData?.is_abstain || 0,
        comment: comments || "",
        total: calculateTotalScore() || "",
        is_pending: 0,
        is_completed: 1,
        is_confirmed: 1,
        criteria: judgingData.flatMap((entry) => {
          const formSchema = JSON.parse(entry.form_schema);

          const titleFields = formSchema.flatMap((schema) =>
            schema.fields.filter((field) => field.label === "Title")
          );

          return titleFields.map((titleField) => {
            const scoreKey = `${entry.scoreFormId}-${titleField.dataName}`;
            return {
              score: selectedScores[scoreKey] || 0,
              score_title: titleField?.value || "Unknown",
              dataName: titleField.dataName || "UnkownDataName",
              is_pending: 0,
              is_completed: 1,
              is_confirmed: 1,
            };
          });
        }),
      };

      const response = await axios.post(
        `${EXCHNAGE_URL_JUDGE}/submitScore`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        toast.success("Scores submitted successfully!");
        navigate(`/jury-entry-listing?${new URLSearchParams(queryParams).toString()}`, {
          state: {
            logoImg,
            eventName,
            fName,
            lName,
            awardCat,
            eventId,
            juryData,
            queryParams,
            eventIdd,
            awardCatId,
            judgeId,
          }
        })
      } else {
        toast.error("Failed to submit scores");
      }
    } catch (error) {
      console.error("Error submitting scores:", error);
      toast.error("Error submitting scores");
    } finally {
      setLoading(false);
    }
  };

  const parseFormula = (scorecard, scores) => {
    try {
      const formula = scorecard.overall_score;
      const titleFields = JSON.parse(scorecard.form_schema)
        .flatMap(schema => schema.fields)
        .filter(field => field.label === "Title");

      let expression = formula;
      const matches = formula.matchAll(/{(\d+)}/g);

      for (const match of matches) {
        const index = parseInt(match[1]) - 1;
        if (index >= 0 && index < titleFields.length) {
          const dataName = titleFields[index].dataName;
          const scoreKey = `${scorecard.scoreFormId}-${dataName}`;
          const value = scores[scoreKey] || 0;
          expression = expression.replace(match[0], value);
        }
      }

      return evaluate(expression);
    } catch (error) {
      console.error("Error parsing formula:", error);
      return 0;
    }
  };
  const calculateTotalScore = () => {
    const totalScore = judgingData.reduce((total, scorecard) => {
      return total + parseFormula(scorecard, selectedScores);
    }, 0);
    return Math.round(totalScore);
  };

  const calculateMaxScore = () => {
    const totalMaxScore = judgingData.reduce((total, scorecard) => {
      const formula = scorecard.overall_score;
      const titleFields = JSON.parse(scorecard.form_schema)
        .flatMap(schema => schema.fields)
        .filter(field => field.label === "Title");

      let maxExpression = formula;
      const matches = formula.matchAll(/{(\d+)}/g);

      for (const match of matches) {
        const index = parseInt(match[1], 10) - 1;
        if (index >= 0 && index < titleFields.length) {
          const maxValue = titleFields[index].maxValue || 10;
          maxExpression = maxExpression.replace(match[0], maxValue);
        }
      }

      try {
        return total + evaluate(maxExpression);
      } catch (error) {
        console.error("Error calculating max score:", error);
        return total;
      }
    }, 0);

    return Math.round(totalMaxScore);
  };

  const fieldValueMap = useMemo(() => {
    const map = {};
    judgingFieldData.forEach((field) => {
      const key = Object.keys(field).find((k) => k !== "entryDataId");
      if (key) {
        map[key] = field[key];
      }
    });
    return map;
  }, [judgingFieldData]);

  const isFieldVisible = useCallback(
    (field) => {
      const {
        visibleInJudgingCondition,
        visibleInJudgingFieldValue,
        visibleInJudgingInConditionValue,
        isVisibleCheckedInJudging,
      } = field;

      // HARD STOP: if "Visible In Judging" is unchecked, hide field
      if (isVisibleCheckedInJudging === false) {
        return false;
      }

      if (
        !visibleInJudgingCondition ||
        !visibleInJudgingFieldValue ||
        !visibleInJudgingInConditionValue
      ) {
        return true;
      }

      const conditions = Array.isArray(visibleInJudgingCondition)
        ? visibleInJudgingCondition
        : [visibleInJudgingCondition];
      const fieldValues = Array.isArray(visibleInJudgingFieldValue)
        ? visibleInJudgingFieldValue
        : [visibleInJudgingFieldValue];
      const conditionValues = Array.isArray(visibleInJudgingInConditionValue)
        ? visibleInJudgingInConditionValue
        : [visibleInJudgingInConditionValue];

      for (let i = 0; i < fieldValues.length; i++) {
        const currentField = fieldValues[i];
        const currentCondition = conditions[i] || conditions[0];
        const expectedValue = conditionValues[i] || conditionValues[0];
        const actualValue = fieldValueMap[currentField];
        console.log("================================");
        console.log("FIELD LABEL:", field.label);
        console.log("currentField:", currentField);
        console.log("actualValue:", actualValue);
        console.log("expectedValue:", expectedValue);
        console.log("condition:", currentCondition);
        console.log("fieldValueMap:", fieldValueMap);
        console.log("================================");
        if (actualValue === undefined) return false;

        let conditionMet;
        switch (currentCondition) {
          case "Equals":
            conditionMet =
              String(actualValue).trim().toLowerCase() ===
              String(expectedValue).trim().toLowerCase();
            break;
          case "contains":
            conditionMet = actualValue.includes(expectedValue);
            break;
          case "startsWith":
            conditionMet = actualValue.startsWith(expectedValue);
            break;
          case "endsWith":
            conditionMet = actualValue.endsWith(expectedValue);
            break;
          case "not-contains":
            conditionMet = !actualValue.includes(expectedValue);
            break;
          case "not-startsWith":
            conditionMet = !actualValue.startsWith(expectedValue);
            break;
          case "not-endsWith":
            conditionMet = !actualValue.endsWith(expectedValue);
            break;
          default:
            conditionMet = actualValue === expectedValue;
        }

        if (!conditionMet) return false;
      }
      return true;
    },
    [fieldValueMap]
  );
  const visibleFields = formSchema.filter(isFieldVisible);
  console.log("FORM SCHEMA", formSchema);

  console.log(
    "VISIBLE FIELDS",
    visibleFields.map((f) => ({
      label: f.label,
      type: f.type,
      dataName: f.dataName,
    }))
  );

  console.log(
    "MEDIA FILES",
    normalJudgeData?.media_files
  );
  return (
    <div>
      <div className="juryentryboard_div">
        <JuryTitleBar
          logoImg={logoImg}
          eventName={eventName}
          fName={fName}
          lName={lName}
        />
        <div className="juryentryboard_white_bg">
          <div className="juryentryboard_head">
            <RedMainHeading>
              Judging - Submission-{" "}
              <span style={{ color: "#777777" }}>Score</span>
            </RedMainHeading>

            <div className="juryentryboard_icon_head">
              <MdOutlineKeyboardArrowLeft />
              <Description>Back to Entry Listing</Description>
            </div>
          </div>

          <div className="juryentryboard_main">
            <div className="juryentryboard_main_sub">
              <span className="juryentryboard_score_div">{submission_id}</span>

              {visibleFields.map((field, index) => {
                const dataName = field.dataName;
                const fieldValue = fieldValueMap[dataName] || "N/A";
                const mediaFile =
                  normalJudgeData?.media_files?.find(
                    file => file.field_name === dataName
                  );
                const formattedHeading = field.label
                  .replace(/-\d+/, "")
                  .replace(/\b\w/g, (char) => char.toUpperCase());

                return (
                  <div
                    className={`juryentryboard_head_content ${index % 2 === 0 ? "bg_grey" : ""
                      }`}
                    key={dataName}
                  >
<SubGreyHeading>
  {containsHTML(formattedHeading) ? (
    <span 
      className="form-label-html"
      dangerouslySetInnerHTML={{ __html: formattedHeading }} 
    />
  ) : (
    formattedHeading
  )}
</SubGreyHeading>                    <StatusSubContent>

                      {field.type === "file" ? (

                        mediaFile ? (
                          <span
                            onClick={() => handleViewMedia(mediaFile)}
                            style={{
                              color: "blue",
                              cursor: "pointer",
                              textDecoration: "underline",
                            }}
                          >
                            View File
                          </span>
                        ) : (
                          "No File"
                        )
                      ) : (
                        fieldValue
                      )}
                    </StatusSubContent>
                                    </div>
                );
              })}
            </div>

            <div className="juryentryboard_main_sub_two">
              <RedMainHeading>Judging Criteria</RedMainHeading>
              <hr />

              {judgingData.map(entry => {
                const formSchema = JSON.parse(entry.form_schema);

                return (
                  <div className="juryentryboard_max_min" key={entry.scoreFormId}>
                    {formSchema.map((schema, schemaIndex) => (
                      <div key={schemaIndex}>
                        {schema.fields.map((field, fieldIndex) => {
                          const scoreKey = `${entry.scoreFormId}-${field.dataName}`;
                          const currentScore = selectedScores[scoreKey] || 0;

                          return (
                            <div
                              className="juryentryboard_sub_max_min"
                              key={`${schemaIndex}-${fieldIndex}`}
                            >
                              {field.label === "Title" && (
                                <>
                                  <div className="juryentryboard_max_min_head">
                                    <SubGreyHeading>{field.value}</SubGreyHeading>
                                    <RedContent>
                                      (Min: {field.minValue || 0}, Max: {field.maxValue || 10})
                                    </RedContent>
                                  </div>

                                  {normalJudgeData.is_abstain === 0 && (
                                    normalJudgeData.is_scoring_dropdown ? (
                                      <SelectBgWhiteBorder
                                        value={currentScore}
                                        onChange={e => handleScoreChange(
                                          entry.scoreFormId,
                                          field.dataName,
                                          e.target.value
                                        )}
                                      >
                                        {Array.from(
                                          { length: field.maxValue - field.minValue + 1 },
                                          (_, i) => i + Number(field.minValue)
                                        ).map(value => (
                                          <option key={value} value={value}>
                                            {value}
                                          </option>
                                        ))}
                                      </SelectBgWhiteBorder>
                                    ) : (
                                      <InputType
                                        type="number"
                                        min={field.minValue}
                                        max={field.maxValue}
                                        value={currentScore}
                                        onChange={e => handleScoreChange(
                                          entry.scoreFormId,
                                          field.dataName,
                                          e.target.value
                                        )}
                                      />
                                    )
                                  )}
                                </>
                              )}

                              {field.label === "Description" && (
                                <StatusSubContent>
                                  {field.value || "No description provided"}
                                </StatusSubContent>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    ))}
                    <hr />
                  </div>
                );
              })}

              {normalJudgeData.is_total === 1 && (
                <div className="juryentryboard_max_min">
                  <div className="juryentryboard_sub_max_min">
                    <div className="juryentryboard_max_min_head">
                      <SubGreyHeading>Total Score:</SubGreyHeading>
                      <RedMainHeading>
                        {calculateTotalScore()} / {calculateMaxScore()}
                      </RedMainHeading>
                    </div>
                    <div className="formula-display">
                      {judgingData.map(scorecard => (
                        <div key={scorecard.scoreFormId}>
                          <small>{scorecard.category}: {scorecard.overall_score}</small>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {/* Comments Section */}
              {normalJudgeData.is_comments_box_judging === 1 && (
                <div className="juryentryboard_comment_box">
                  <SubGreyHeading>Comments:</SubGreyHeading>
                  <InputTextarea
                    value={comments}
                    onChange={e => setComments(e.target.value)}
                    placeholder="Provide feedback..."
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div style={{ display: "flex", justifyContent: "end" }}>
        <RedMainHeading>
          <GreyBackgroundButton
            style={{
              width: "fit-content",
              padding: "0.8rem 2rem",
              marginLeft: "1rem",
            }}
            onClick={() =>
              navigate(
                `/jury-entry-listing?${new URLSearchParams(
                  queryParams
                ).toString()}`,
                {
                  state: {
                    logoImg,
                    eventName,
                    fName,
                    lName,
                    awardCat,
                    eventId,
                    juryData,
                    queryParams,
                    eventIdd,
                    awardCatId,
                  },
                }
              )
            }
          >
            Back to Entry Listing
          </GreyBackgroundButton>
        </RedMainHeading>

        <RedMainHeading>
          <RedBackgroundButton
            style={{
              width: "fit-content",
              padding: "0.8rem 2rem",
              margin: "0rem 1rem",
            }}
            onClick={handleSubmitScores}
          >
            Submit Scores
          </RedBackgroundButton>
        </RedMainHeading>
      </div>
    {showMediaModal && selectedMedia && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,.7)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999,
    }}
    onClick={() => setShowMediaModal(false)}
  >
    <div
      style={{
        width: "90%",
        height: "90%",
        background: "#fff",
        padding: "10px",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {selectedMedia.mime_type?.startsWith("image/") ? (
        <img
          src={selectedMedia.file_url}
          alt="preview"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        />
      ) : selectedMedia.mime_type === "application/pdf" ? (
        <iframe
          src={selectedMedia.file_url}
          title="PDF Preview"
          width="100%"
          height="100%"
        />
      ) : (
        <div style={{ textAlign: "center", paddingTop: "100px" }}>
          <h3>Preview not available</h3>

          <a
            href={selectedMedia.file_url}
            target="_blank"
            rel="noopener noreferrer"
          >
            Open / Download File
          </a>
        </div>
      )}
    </div>
  </div>
)}
    </div>
  );
};
